export const lightTheme = {};
